import { Component, OnInit } from '@angular/core';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  get titleLabel(){ return "Cos’è MyPay" }
  get titleIcon(){ return faInfo }

  constructor() { }

  ngOnInit(): void {
  }

}
